import * as React from "react";

import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { sections } from "../config";
import { theme } from "../components/theme";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const MainDecorator = (props: React.PropsWithChildren) => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg">
        <Header title="Blog" sections={sections} />
      </Container>
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Container
          sx={{
            flex: "1 0 auto",
          }}
        >
          {props.children}
        </Container>
        <Container
          sx={{
            flexShrink: 0,
          }}
        >
          <Footer />
        </Container>
      </Container>
    </ThemeProvider>
  );
};

export default MainDecorator;